import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../state';
import { ConfigContainer } from './ConfigContainer';

export const mapState = (state: RematchRootState<RootModel>) => {
  const connection = state.connections.connection;
  return {
    project: state.projects.project,
    tabIsDefault: state.connections.tabIsDefault,
    connections: state.connections.connections,
    connectionName: connection?.name,
    connectionId: connection?.id,
    service: state.services.service,
    services: state.services.services,
    tabName: state.tab.tabName,
    defaultRoute: state.services.defaultRoute,
    iModel: state.imodels.iModel,
  };
};

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({});

export const ConnectedConfigContainer = connect(
  mapState,
  mapDispatch
)(ConfigContainer);
